import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseLocationPartsDataGrid } from "src/components/views/erp/warehouse/warehouseLocationParts/WarehouseLocationPartsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/warehouseLocationParts")({
	staticData: { title: i18n.t("warehouse_location_parts"), legacyViewKey: "warehouseLocationPartsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehouseLocationPartsDataGrid />;
}
